var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_115_1275",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_115_1275)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3193 26C53.0164 26.2688 48.7184 27.3463 44.6553 29.2883L55.0504 43.2647L57.3193 26Z",
    fill: "url(#paint0_linear_115_1275)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2191 55.2313L38.5841 35.3273L34.3708 58.8175L26.3196 59.8926L28.4989 45.2914C26.787 48.8073 25.6828 52.5872 25.2324 56.4542C24.4697 63.0065 25.5714 69.8107 28.7289 76.0216C36.5574 72.8011 45.9137 67.9075 55.5703 61.7764C59.3284 59.3913 62.8951 56.9675 66.2197 54.5606L51.2191 55.2289V55.2313Z",
    fill: "url(#paint1_radial_115_1275)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.143 28.3367C70.6974 27.7676 69.2155 27.3003 67.7094 26.9322L66.2227 54.563C74.424 48.6257 81.1507 42.7877 85.5891 37.8577C81.8626 33.5403 77.2231 30.3295 72.1454 28.3342L72.143 28.3367Z",
    fill: "url(#paint2_linear_115_1275)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8985 42.393C82.4842 48.8025 72.6992 56.2217 60.9965 62.8588C49.3108 69.4862 38.5863 75.5833 30.0557 78.661C38.2788 91.1942 53.7177 97.0928 67.7135 93.8481L71.1035 89.4895L57.3789 66.181L74.3627 66.6314L78.1014 81.4068C82.1234 78.8547 86.712 66.888 86.712 66.888L92.458 66.8759C89.8792 76.179 83.0629 84.3828 77.5275 89.8285C77.6801 89.7365 77.8302 89.6445 77.9803 89.5501C93.9157 79.4358 98.7343 58.4228 88.8961 42.393H88.8985Z",
    fill: "url(#paint3_radial_115_1275)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5077 30.9252C84.3143 29.0268 89.053 28.9808 90.4066 31.2254C91.5059 33.0487 90.2274 36.1385 87.1135 39.9837C81.3311 47.122 69.2071 56.8634 54.1556 65.9437C45.5305 71.1449 37.1669 75.3896 29.8954 78.4067C28.7404 78.8862 27.6096 79.3365 26.5127 79.753C27.6387 79.4382 28.8203 79.075 30.0528 78.661C38.6513 75.7795 49.7147 70.5323 61.2334 63.5828C72.7521 56.6358 82.5564 49.2989 89.116 43.0371C95.7458 36.7099 99.0632 31.4821 97.4844 28.8645C95.6998 25.9056 88.0385 26.9274 77.5053 30.9227L77.5077 30.9252Z",
    fill: "#13234D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_115_1275",
    x1: 53.8155,
    y1: 19.7043,
    x2: 50.9098,
    y2: 52.7567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46AEE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_115_1275",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.3981 44.6449) rotate(93.4643) scale(54.0964 54.7949)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.135655,
    stopColor: "#BAE5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355374,
    stopColor: "#46AEE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628544,
    stopColor: "#132857"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_115_1275",
    x1: 59.3845,
    y1: 32.7799,
    x2: 92.1947,
    y2: 40.7706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46AEE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32358C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_115_1275",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.8412 60.0209) rotate(43.4926) scale(32.5431 32.0637)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46AEE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357212,
    stopColor: "#1B59B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887306,
    stopColor: "#132857"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo12);
export default __webpack_public_path__ + "static/media/logo12.d6ea0a07abd4ba2995fdce1c7c680208.svg";
export { ForwardRef as ReactComponent };